import { h, defineComponent, SetupContext, VNodeChildren } from 'vue';

export const FilterContainer = defineComponent({
  name: 'FilterContainer',
  setup(_, context: SetupContext) {
    return function render() {
      return h(
        'div',
        { class: 'column is-narrow is-relative is-unselectable' },
        context.slots.default?.(),
      );
    };
  },
});

export function filterContainer(contents: VNodeChildren) {
  return h(FilterContainer, contents);
}
